
import { domReady } from "./core/dom-ready.js";
import { initApp } from "./core/init-app.js";
import { initReveal } from "./modules/reveal/reveal.js";

domReady(() => {
  // modules/components 起動（data-module / data-component を走査）
  initApp(document);

  // スクロール表示アニメーション（.js-reveal / .js-reveal-item が存在するページのみ有効）
  initReveal(document);
});
